<div class="section container-fluid pt-5 pb-4">
    <span class="section-title">Find your midwife</span>
    <div class="row justify-content-center py-4" *ngIf="!loading">
        <div class="col-sm-4 col-xl-2 mt-3" *ngFor="let midwife of midwifes">
            <app-profile-card [midwife]="midwife"></app-profile-card>
        </div>
    </div>
    <button class="btn btn-theme" *ngIf="!loading" [routerLink]="['/search-listing']">View All</button>
    <div class="row my-5" *ngIf="loading">
        <div class="spinner-border loader" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</div>